// PDF React View
import { TCTBAO_LABEL } from "pages/InvoiceInvoiceErrors/utils";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { Label, Modal, ModalBody, ModalHeader } from "reactstrap";
const DetailModal = props => {
  const { isOpen, toggle, dataDetail } = props;

  useEffect(() => {
    if (isOpen) {
    } else {
    }
  }, [isOpen]);

  const numberWithCommas = (x, isShow) => {
    let dau = "";
    if (isShow) {
      dau = x > 0 ? "+" : "";
    }
    return dau + x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  return (
    <Modal
      size="xl"
      contentClassName="confirm-modal"
      isOpen={isOpen}
      role="dialog"
      style={{ maxWidth: "80%" }}
      autoFocus={true}
      centered={true}
      className="exampleModal"
      toggle={toggle}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>
          <Label>Nội dung bảng tổng hợp dữ liệu</Label>
        </ModalHeader>
        <ModalBody>
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr className="text-info">
                  <th scope="col">STT</th>
                  <th style={{ width: "200px" }}>Ký hiệu mẫu số hóa đơn</th>
                  <th style={{ width: "100px" }}>Ký hiệu hóa đơn</th>
                  <th style={{ width: "100px" }}>Số hóa đơn</th>
                  <th style={{ width: "100px" }}>Ghi chú</th>
                  <th style={{ width: "100px" }}>Ngày lập</th>
                  <th style={{ width: "300px" }}>Tên người mua</th>
                  <th style={{ width: "100px" }}>Thuế suất</th>
                  <th style={{ width: "100px" }}>Trạng thái</th>
                  <th style={{ width: "100px" }}>Đơn vị tính</th>
                  <th style={{ width: "100px" }}>Số lượng</th>
                  <th style={{ width: "170px" }}>Tên hàng hóa, dịch vụ</th>
                  <th style={{ width: "100px" }}>Mã số thuế người mua</th>
                  <th style={{ width: "200px" }}>
                    Tổng giá trị hàng hóa, dịch vụ bán ra chưa có thuế GTGT
                  </th>
                  <th style={{ width: "100px" }}>Tổng tiền thuế </th>
                  <th style={{ width: "100px" }}>Tổng tiền thanh toán</th>
                </tr>
              </thead>

              <tbody>
                {dataDetail?.ndbthdlieu &&
                  dataDetail?.ndbthdlieu.map((item, key) => (
                    <tr key={key}>
                      <td>{key + 1}</td>
                      <td>{item.KHMSHDon}</td>
                      <td>{item.KHHDon}</td>
                      <td>{item.SHDon}</td>
                      <td>{item.GChu}</td>
                      <td>{item.NLap}</td>
                      <td>{item.TNMua}</td>
                      <td>{item.TSuat}</td>
                      <td>{TCTBAO_LABEL[item.TThai]}</td>
                      <td>{item.DVTinh}</td>
                      <td>{item.SLuong}</td>
                      <td>{item.THHDVu}</td>
                      <td>{item.MSTNMua}</td>
                      <td>{numberWithCommas(item.TTCThue)}</td>
                      <td>{numberWithCommas(item.TgTThue)}</td>
                      <td>{numberWithCommas(item.TgTTToan)}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </ModalBody>
      </div>
    </Modal>
  );
};

DetailModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  dataDetail: PropTypes.any,
};

export default DetailModal;
